import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Fragment } from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Bookmark, Bookmarked } from '@finect/tabular-icons/bookmark';
import { Heart } from '@finect/tabular-icons/heart';
import { MessageCircle } from '@finect/tabular-icons/messageCircle';
import { Share as ShareIcon } from '@finect/tabular-icons/share';
import { CheckCircle } from '@finect/tabular-icons/checkCircle';
import { Share } from './../../../Share';
import { Tooltip } from './../../../Tooltip';
import { Action } from './Action';
import { Count } from './Count';
export var ToolbarItems = function ToolbarItems(_ref) {
  var like = _ref.like,
    save = _ref.save,
    respond = _ref.respond,
    share = _ref.share,
    select = _ref.select;
  var respondProps = respond && !respond.disable ? respond.action ? {
    onClick: respond.action
  } : {
    as: AppLink,
    href: respond.path || ''
  } : {};
  return React.createElement(Fragment, null, select ? React.createElement(Action, {
    color: "success",
    done: select.done,
    maxScale: 1.05,
    fill: "none",
    onClick: !select.disable ? select.action : null
  }, React.createElement(CheckCircle, null), React.createElement("span", null, "Mejor respuesta")) : null, like ? React.createElement(Tooltip, {
    disabled: !like.disable,
    from: "left",
    display: "block",
    width: "180px",
    tip: like.disable
  }, React.createElement(Action, {
    color: "secondary",
    done: like.done,
    onClick: !like.disable ? like.action : null,
    disabled: Boolean(like.disable)
  }, React.createElement(Count, null, like.qty || 0), React.createElement(Heart, null), React.createElement("span", null, "Me gusta"))) : null, respond ? React.createElement(Tooltip, {
    disabled: !respond.disable,
    from: "left",
    display: "block",
    width: "180px",
    tip: respond.disable
  }, React.createElement(Action, _extends({
    color: "primary"
  }, respondProps, {
    disabled: Boolean(respond.disable)
  }), React.createElement(MessageCircle, {
    style: {
      position: 'relative',
      top: '-1px'
    }
  }), React.createElement("span", null, "Comentar"))) : null, save ? React.createElement(Action, {
    done: save.done,
    maxScale: 1.05,
    onClick: save.action
  }, save.done ? React.createElement(Bookmarked, null) : React.createElement(Bookmark, null), React.createElement("span", null, save.done ? 'Guardado' : 'Guardar')) : null, share ? React.createElement(Share, {
    title: share.title,
    url: "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com').concat(share.path),
    via: "Finect",
    arrowPosition: 3,
    positionX: "top"
  }, React.createElement(Action, null, React.createElement(ShareIcon, null), React.createElement("span", null, "Compartir"))) : null);
};